export const isValidEmail = (email) =>
     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email?.trim());

export const isValidUKPhone = (phone) => {
     const cleaned = phone?.replace(/[\s()-]/g, "");
     return /^(?:\+44|0)7\d{9}$|^(?:\+44|0)[1-3]\d{8,9}$/.test(cleaned);
};

// ---------------- DOB RANGE (AGES 7–11) ----------------
export const getDOBRange = (minAge = 11, maxAge = 7) => {
     const today = new Date();

     const minDOB = new Date(
          today.getFullYear() - minAge,
          today.getMonth(),
          today.getDate()
     );

     const maxDOB = new Date(
          today.getFullYear() - maxAge,
          today.getMonth(),
          today.getDate()
     );

     return { minDOB, maxDOB };
};

// format date → YYYY-MM-DD
export const formatDate = (date) =>
     date.toISOString().split("T")[0];

// validate DOB is within range
export const isValidDOBRange = (dateOfBirth, minDOB, maxDOB) => {
     if (!dateOfBirth) return true; // optional

     const dob = new Date(dateOfBirth);

     return dob >= minDOB && dob <= maxDOB;
};


export const GetOnboarderDOBRange = (minAge = 18) => {
     const today = new Date();

     const minODOB = new Date(
          today.getFullYear() - minAge,
          today.getMonth(),
          today.getDate()
     );

     return { minODOB };
};

export const isValidOnboarderDOBRange = (dateOfBirth, minODOB) => {
     if (!dateOfBirth) return true; // optional

     const dob = new Date(dateOfBirth);

     return dob >= minODOB;
};


